module.exports = __webpack_public_path__ + "static/media/send-2.b00c7a5e.svg";